import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import Cropper from 'react-cropper'
import {Row,Col} from 'react-flexbox-grid'
import { RotateLeft , RotateRight } from '@material-ui/icons'
import 'cropperjs/dist/cropper.css'

import './styles.css'

class CropperModal extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            disabled: true,
            cropResult: null,
        }
        this.cropImage = this.cropImage.bind(this);
    }

    cropImage() {
        
        if (this.cropper.getCroppedCanvas() === null) {
          return;
        }
        
        this.setState({
            disabled: false,
            cropResult: this.cropper.getCroppedCanvas().toDataURL(),
        });
    }

    onGuardar = () => {
        let cropBoxData = this.cropper.getCropBoxData()

        this.cropper.getCroppedCanvas({}).toBlob((blob) => {
            this.props.handleOnSaveImagenCortada(this.state.cropResult, blob, cropBoxData)
        })
    }

    rotarDerecha = () => {
        this.cropper.rotate(90)
    }

    rotarIzquierda = () => {
        this.cropper.rotate(-90)
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                className='cropperModal'
            >
                <DialogContent >
                    <DialogContentText id="alert-dialog-description">

                        <Row >
                            <Col xs={5} >
                                <h3>
                                    <span>Imagen original</span>
                                </h3>
                                <Cropper
                                    style={{ height: 450 }}
                                    aspectRatio={(this.props.ratio)?this.props.ratio:1 / 1}
                                    preview=".img-preview"
                                    autoCrop={true}
                                    guides={false}
                                    src={this.props.src}
                                    ref={cropper => { this.cropper = cropper; }}
                                    zoomable= {true}
                                    viewMode={2}
                                />
                            </Col>

                            <Col xs={2} className='rowCortar'>
                                <div className='girar'>
                                    <h4 style={{margin: '0px' , marginBottom: '10px'}}>
                                        <span >Girar imagen</span>
                                    </h4>
                                    {/* BOTON GIRAR DERECHA */}
                                    <Button onClick={this.rotarIzquierda} className="btnPrincipal btn">
                                        <RotateLeft />
                                    </Button>

                                    {/* BOTON GIRAR IZQUIERDA */}
                                    <Button onClick={this.rotarDerecha} className="btnPrincipal btn">
                                        <RotateRight />
                                    </Button>
                                </div>
                                <div className=''>
                                    {/* BOTON CORTAR IMAGEN */}
                                    <Button onClick={this.cropImage} className="btnPrincipal btn btnCortar">
                                        Cortar
                                    </Button>
                                    
                                    {/*<div className="box" style={{ width: '50%', float: 'right' }}>
                                        <h3>Preview</h3>
                                        <div className="img-preview" style={{ width: '100%', float: 'left', height: 100 }} />
                                    </div>*/}
                                </div>
                            </Col>

                            <Col xs={5} className="box" >
                                <h3>
                                <span>Imagen final</span>
                                </h3>
                                <div className={`${this.props.modalArticulo === false? "imgContainer" : "imgContainerArticulo"}`}>
                                    {this.state.cropResult !== null ?
                                        <img height={450} alt="cropped img" src={this.state.cropResult} className='borderImg'/>
                                        : <div className={`${this.props.modalArticulo === false? "divOtro" : "divArticulo"}`}></div>   
                                    }
                                </div>
                            </Col>
                        </Row>
                        
                    </DialogContentText>
                </DialogContent>

                <DialogActions className='botenes'>
                    <Button onClick={() => {this.props.handleOnCloseCropperModal()}} className="btnPrincipal btn">
                        Volver
                    </Button>
                    {/*<Button onClick={this.cropImage} className="btnPrincipal btn">
                        Cortar
                    </Button>*/}
                    <Button disabled={this.state.disabled} onClick={this.onGuardar} className="btnPrincipal btn">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

CropperModal.propTypes = {
    handleOnCloseCropperModal: PropTypes.func,
    handleOnSaveImagenCortada: PropTypes.func,
    ratio: PropTypes.number,
    src: PropTypes.object,
    open: PropTypes.object,
    modalArticulo: PropTypes.object,
}

CropperModal.defaultProps = {
    modalArticulo: false,
    handleOnClose: f => f
}

export default CropperModal